import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faCheckSquare as regularCheckSquare,
    faArrowToTop,
    faArrowToBottom,
    faSquare,
    faKey,
    faCopy,
    faSync as faRegSync,
    faSlidersH,
    faArrowUp,
    faArrowDown,
    faArrowFromLeft,
    faArrowFromTop,
    faArrowFromRight,
    faArrowFromBottom,
} from '@fortawesome/pro-regular-svg-icons';
import {
    faQuestionCircle,
    faUserFriends,
    faEdit,
    faShareSquare,
    faUndoAlt,
    faRedoAlt,
    faSave,
    faLaptop,
    faMobileAlt,
    faTrash,
    faLockAlt,
    faLockOpenAlt,
    faSync,
    faChevronDown,
    faChevronUp,
    faExclamationCircle,
    faTimes,
    faTimesCircle,
    faTimesOctagon,
    faExclamationTriangle,
    faBold,
    faItalic,
    faUnderline,
    faAlignLeft,
    faAlignRight,
    faAlignCenter,
    faAngleDown,
    faAngleUp,
    faCog,
    faLock,
    faUserPlus,
    faMagic,
    faSearch,
    faFolder,
    faUser,
    faCalendarDay,
    faPlusCircle,
    faCloudUpload,
    faCheck,
    faCheckCircle,
    faPencil,
    faCheckSquare as solidCheckSquare,
    faArrowAltToTop,
    faStar,
    faArrowRight,
    faExternalLink,
    faLink,
    faUnlink,
    faSortUp,
    faSortDown,
    faSpinnerThird,
    faLightbulbOn,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
    faQuestionCircle,
    faUserFriends,
    faShareSquare,
    faUndoAlt,
    faRedoAlt,
    faSave,
    faMobileAlt,
    faLaptop,
    faTrash,
    faLockAlt,
    faLockOpenAlt,
    faSync,
    faRegSync,
    faChevronDown,
    faChevronUp,
    faExclamationCircle,
    faTimes,
    faTimesCircle,
    faTimesOctagon,
    faExclamationTriangle,
    faBold,
    faItalic,
    faUnderline,
    faAlignLeft,
    faAlignRight,
    faAlignCenter,
    faCog,
    faCopy,
    faExclamationTriangle,
    faLock,
    faUserPlus,
    faMagic,
    faEdit,
    faSearch,
    faFolder,
    faUser,
    faCalendarDay,
    faPlusCircle,
    faCloudUpload,
    faCheck,
    faCheckCircle,
    faPencil,
    faSlidersH,
    faSquare,
    solidCheckSquare,
    regularCheckSquare,
    faAngleDown,
    faAngleUp,
    faArrowAltToTop,
    faArrowDown,
    faArrowUp,
    faArrowRight,
    faArrowToTop,
    faArrowToBottom,
    faStar,
    faExternalLink,
    faKey,
    faLink,
    faUnlink,
    faArrowFromLeft,
    faArrowFromTop,
    faArrowFromRight,
    faArrowFromBottom,
    faSortUp,
    faSortDown,
    faSpinnerThird,
    faLightbulbOn,
);
